import produce from "immer";
import {ACTION_TYPE} from "utils/constants";
import profileDefaultImage from "images/common/avatar-default-profile-image.png";

const initialState = {
  id: null,
  email: "",
  name: "",
  birth: "",
  gender: "",
  icon: profileDefaultImage,
  phone: "",
  verifiedEmail: "",
  isMarketingAgreement: false,
};

const userinfo = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPE.UPDATE_USERINFO:
      return {...state, id: action.payload.ci, ...action.payload};
    case ACTION_TYPE.LOGOUT:
      localStorage.removeItem("redbrickToken");
      return {
        ...initialState,
      };
    case ACTION_TYPE.LOGIN:
      return produce(state, draft => {
        draft.action = {
          id: action.payload.ci,
          email: action.payload.email,
          verifiedEmail: action.payload.verifiedEmail,
          name: action.payload.name,
          birth: action.payload.birth,
          gender: action.payload.gender,
          icon: action.payload.icon,
          phone: action.payload.phone,
          isMarketingAgreement: action.payload.isMarketingAgreement,
        };
      });
    default:
      return state;
  }
};

export default userinfo;
